import axios from "axios";
import React, { useState, useEffect } from "react";
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    CardHeader,
    Input,
    Label,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    FormGroup,
    UncontrolledPopover,
    PopoverHeader,
    PopoverBody,
    Toast,
    ToastHeader,
    ToastBody,
} from "reactstrap";
import { SearchResult, useAuth } from "../../Provider/AuthProvider";


const Caisse = () => {

    const { user, order, changeOrder } = useAuth();

    const calculateTotals = () => {
        if (!order?.lines) return { totalHT: 0, totalTVA: 0 };
        const totalHT = order.lines.reduce(
            (sum, line) => sum + parseFloat(line.total_ht || "0"),
            0
        );
        const totalTVA = order.lines.reduce(
            (sum, line) => sum + parseFloat(line.total_tva || "0"),
            0
        );
        return { totalHT, totalTVA };
    };

    const [montant, setMontant] = useState("");
    const [orderDetailsModalOpen, setOrderDetailsModalOpen] = useState(false);
    const [selectedPayment, setSelectedPayment] = useState("");
    const [modalOpen, setModalOpen] = useState(false);
    const [pdfModalOpen, setPdfModalOpen] = useState(false);
    const [resteAPayer, setResteAPayer] = useState(order?.resteapayer || 0);

    const [showToast, setShowToast] = useState(false);
    const [paymentDetails, setPaymentDetails] = useState({
        transactionId: "",
        bank: "",
    });
    const [orders, setOrders] = useState<SearchResult[]>([]);
    const [id, setId] = useState(0);

    const toggleOrderDetailsModal = () => {
        setOrderDetailsModalOpen(prev => !prev);
    };

    const togglePdfModal = () => {
        setPdfModalOpen(!pdfModalOpen);
        if (pdfModalOpen) {
            changeOrder(null); 
        }
    };

    const handleModalClose = () => {
        setModalOpen(false);
        setSelectedPayment("");
        setPaymentDetails({ transactionId: "", bank: "" });
    };

    const isSearchInputFocused = () => {
        const searchInput = document.getElementById("search-options") as HTMLInputElement;
        return document.activeElement === searchInput;
    };




    const fetchCommandes = async () => {
        try {
            const response = await axios.post(
                "/apiV2/",
                { action: "topay", entity: user.entity },
                {
                    baseURL: "https://api.apapiecesauto.fr",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${user.token}`,
                    },
                }
            );

            const listCommandes: SearchResult[] = response.data || [];
            const existingIds = new Set(orders.map((f) => f.id));
            const ids = new Set(listCommandes.map((f) => f.id));
            const uniqueNewFactures = listCommandes.filter((c) => !existingIds.has(c.id));
            const updatedFactures = [...orders.filter((f) => ids.has(f.id)), ...uniqueNewFactures];


            setOrders(updatedFactures);

            // Only select newest facture if no facture is selected and search input is not focused
            if (!order && !isSearchInputFocused() && updatedFactures.length > 0) {
                const newestFacture = updatedFactures[0];
                setId(parseInt(newestFacture.id));
            }
        } catch (error) {
            console.error("Error fetching orders:", error);
        }
    };



    useEffect(() => {
        fetchCommandes();
        const intervalId = setInterval(fetchCommandes, 10000);
        return () => clearInterval(intervalId);
    }, [fetchCommandes]);


    useEffect(() => {
        console.log(order, "order")
        if (!order && orders.length > 0 && !isSearchInputFocused()) {
            const newestFacture = orders[0];
            changeOrder(newestFacture);
            setId(parseInt(newestFacture.id));
        }
    }, [orders, montant])



    const isMontantValid = () => {
        if (!order) return false;

        const amount = parseFloat(montant);
        // Check if amount is a valid number, greater than 0, and <= resteAPayer
        return !isNaN(amount) && amount > 0 && amount <= order.resteapayer;
    };


    const isPaymentEnabled = isMontantValid();
    const errorMessage =
        !isMontantValid() && montant !== ""
            ? "Le montant doit être entre 0 et le reste à payer."
            : "";

    const handleBackspace = () => {
        setMontant((prev) => prev.slice(0, -1));
        setSelectedPayment("");
        setPaymentDetails({ transactionId: "", bank: "" });
        setModalOpen(false);
    };

    const handleClearAll = () => {
        setMontant("");
        setSelectedPayment("");
        setPaymentDetails({ transactionId: "", bank: "" });
        setModalOpen(false);
    };

    const handleNumberClick = (value: string) => {
        setMontant((prev) => {
            if (value === "." && prev.includes(".")) return prev;
            if (value === "." && prev === "") return "0.";
            if (prev === "0" && value !== ".") return value;
            const [integerPart, decimalPart] = prev.split(".");
            if (decimalPart && decimalPart.length >= 2 && value !== "") return prev;
            return prev + value;
        });
    };

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let value = e.target.value;

        if (value === "" || /^\d*\.?\d*$/.test(value)) {
            // Remove leading zeros unless it's "0." or similar
            if (value.startsWith("0") && value.length > 1 && !value.startsWith("0.")) {
                value = value.replace(/^0+/, "");
                if (value === "") value = "0";
            }
            setMontant(value);

            if (value === "") {
                setSelectedPayment("");
                setPaymentDetails({ transactionId: "", bank: "" });
                setModalOpen(false);
            }
        }
    };



    const getPaymentCode = (method: string) => {
        switch (method) {
            case "Espèce":
                return "LIQ";
            case "Carte Bancaire":
                return "CB";
            case "Cheque":
                return "CHQ";
            default:
                return "";
        }
    };


    const popupStyle: React.CSSProperties = {
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 1050,
        backgroundColor: 'white',
        width: '80%',
        maxWidth: '800px',
        maxHeight: '80vh',
        overflowY: 'auto' as const,  // Use 'as const' for literal types
        padding: '20px',
        borderRadius: '5px',
        boxShadow: '0 5px 15px rgba(0,0,0,0.5)',
        display: 'none'
    };

    const popupBackdrop: React.CSSProperties = {
        position: 'fixed' as const,
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 1040,
        backgroundColor: 'rgba(0,0,0,0.5)',
        display: 'none'
    };


    const handlePaymentSelection = (method: string) => {
        setSelectedPayment(method);
        if (method === "Cheque" || method === "Carte Bancaire") {
            setModalOpen(true);
        } else {
            setPaymentDetails({ transactionId: "", bank: "" });
        }
    };

    const handlePaymentDetailsChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setPaymentDetails((prev) => ({ ...prev, [name]: value }));
    };


    const handleFactureSelect = (selectedOrder: SearchResult) => {
        changeOrder(selectedOrder); // Update the selected order in the context/state
        setId(parseInt(selectedOrder.id)); 
    };

    const handlePayment = async () => {
        if (!order || !isPaymentEnabled) return;

        const payload = {
            action: 'paiement',
            ref: order.ref,
            entity: user.entity,
            code: getPaymentCode(selectedPayment),
            amount: parseFloat(montant).toFixed(2),
            ...(selectedPayment === 'Cheque'
                ? {
                    bank: paymentDetails.bank,
                    transaction_id: paymentDetails.transactionId,
                }
                : selectedPayment === 'Carte Bancaire'
                    ? {
                        transaction_id: paymentDetails.transactionId,
                    }
                    : {}),
        };

        try {
            axios.post(
                "/apiV2/",
                payload,
                {
                    baseURL: "https://api.apapiecesauto.fr",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${user.token}`,
                    },

                }
            ).then(async (data: any) => {
                const updatedInvoice: SearchResult = data.object;
                if (updatedInvoice) {
                    changeOrder(updatedInvoice);
                    setId(parseInt(updatedInvoice.id));

                }
                setShowToast(true);
                setTimeout(() => setShowToast(false), 3000);

                const commandesResponse = await axios.post(
                    "/apiV2/",
                    { action: "topay", entity: user.entity },
                    {
                        baseURL: "https://api.apapiecesauto.fr",
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": `Bearer ${user.token}`,
                        },
                    }
                );
                const newCommandes: SearchResult[] = commandesResponse.data || [];
                setOrders((prev) => {
                    const existingIds = new Set(prev.map((f) => f.id));
                    const uniqueNewFactures = newCommandes.filter((f) => !existingIds.has(f.id));
                    const updatedFactures = [...prev, ...uniqueNewFactures];
                    if (order === null && !isSearchInputFocused() && updatedFactures.length > 0) {
                        const newestFacture = updatedFactures[0];
                        changeOrder(newestFacture);
                        setId(parseInt(newestFacture.id));

                    }
                    return updatedFactures;
                });

            });
        } catch (error) {
            console.error('Erreur lors du paiement:', error);
        }

        setModalOpen(false);
        setMontant('');
        setSelectedPayment('');
        setPaymentDetails({ transactionId: '', bank: '' });
    };


    useEffect(() => {
        if (order) {
            setMontant(order.resteapayer.toFixed(2));
            setResteAPayer(order.resteapayer);
        } else {
            setMontant("");
            setResteAPayer(0);
        }
        setSelectedPayment("");
        setPaymentDetails({ transactionId: "", bank: "" });
    }, [order]);

    useEffect(() => {
        if (!isMontantValid()) {
            setSelectedPayment("");
            setPaymentDetails({ transactionId: "", bank: "" });
            setModalOpen(false);
        }
    }, [montant]);


    return (
        <React.Fragment>
            <div className="page-content pb-0">
                <Container fluid>
                    <Row>
                        {/* Left Column: Order Details, Payment Methods, and Keypad */}
                        <Col xl="8">
                            {/* Order Details Card */}
                            {order ? (
                                <Card
                                    className="mb-4 border border-2 border-primary"
                                    style={{ minHeight: 150, maxHeight: 150, height: 150 }}
                                >
                                    <CardHeader className="bg-primary bg-opacity-10 border-bottom border-primary border-opacity-25">
                                        <Row>
                                            <Col md={4}>
                                                <div className="d-flex align-items-center">
                                                    <i className="ri-shopping-bag-line align-middle me-2 fs-3"></i>
                                                    <div style={{ position: 'relative', display: 'inline-block' }}>
                                                        <button
                                                            type="button"
                                                            style={{
                                                                border: 'none',
                                                                background: 'none',
                                                                padding: 0,
                                                                cursor: 'zoom-in',
                                                                textDecoration: 'none',
                                                                color: 'inherit',
                                                                fontWeight: 'inherit'
                                                            }}
                                                            onMouseEnter={() => setOrderDetailsModalOpen(true)}
                                                            onMouseLeave={() => setOrderDetailsModalOpen(false)}
                                                            onClick={() => setOrderDetailsModalOpen(!orderDetailsModalOpen)}
                                                        >
                                                            {order.ref}
                                                        </button>

                                                        {/* Custom Popup */}
                                                        {orderDetailsModalOpen && (
                                                            <>
                                                                <div
                                                                    style={popupBackdrop}
                                                                    onClick={() => setOrderDetailsModalOpen(false)}
                                                                />
                                                                <div
                                                                    style={{ ...popupStyle, display: 'block' }}
                                                                    onMouseEnter={() => setOrderDetailsModalOpen(true)}
                                                                    onMouseLeave={() => setOrderDetailsModalOpen(false)}
                                                                >
                                                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                                                                        <h5 style={{ color: '#405189', fontFamily: '"roboto", Times, serif' }}>
                                                                            Détails de la commande {order?.ref}
                                                                        </h5>
                                                                    </div>
                                                                    <hr style={{ borderTop: '1px solid #dee2e6', margin: '15px 0' }} />
                                                                    <div className="table-responsive" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                                                                        <table className="table table-sm mb-0">
                                                                            <thead className="table-light">
                                                                                <tr>
                                                                                    <th style={{ width: '50%', fontFamily: '"roboto", Times, serif' }}>Produit</th>
                                                                                    <th className="text-end" style={{ width: '15%', fontFamily: '"roboto", Times, serif' }}>Prix</th>
                                                                                    <th className="text-end" style={{ width: '15%', fontFamily: '"roboto", Times, serif' }}>Qté</th>
                                                                                    <th className="text-end" style={{ width: '20%', fontFamily: '"roboto", Times, serif' }}>Total</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {order?.lines.map((line, key) => (
                                                                                    <tr key={key}>
                                                                                        <td className="text-truncate" style={{ maxWidth: '300px', fontFamily: '"roboto", Times, serif' }}>
                                                                                            {line.description}
                                                                                        </td>
                                                                                        <td className="text-end" style={{ fontFamily: '"roboto", Times, serif' }}>{Number(line.unit_price_ttc).toFixed(2)} €</td>
                                                                                        <td className="text-end" style={{ fontFamily: '"roboto", Times, serif' }}>{line.qty}</td>
                                                                                        <td className="text-end" style={{ fontFamily: '"roboto", Times, serif' }}>{Number(line.total_ttc).toFixed(2)} €</td>
                                                                                    </tr>
                                                                                ))}
                                                                            </tbody>
                                                                            <tfoot style={{ marginBottom: '20px' }}>
                                                                                <tr className="border-top border-dark fw-semibold">
                                                                                    <td colSpan={3} className="text-end" style={{ fontFamily: '"roboto", Times, serif' }}>Total TTC :</td>
                                                                                    <td className="text-end" style={{ fontFamily: '"roboto", Times, serif' }}>{Number(order?.total_ttc).toFixed(2)} €</td>
                                                                                </tr>
                                                                            </tfoot>
                                                                        </table>
                                                                    </div>
                                                                    <hr style={{ borderTop: '1px solid #dee2e6', margin: '15px 0' }} />
                                                                    <div style={{ textAlign: 'right', marginTop: '20px' }}>
                                                             
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                            </Col>

                                            <Col md={4} className="text-end">
                                                {order?.invoicepdf && (
                                                    <Button
                                                        color="link"
                                                        size="m"
                                                        className="p-0 text-success"
                                                        style={{ float: "right" }}
                                                        title="Voir la facture"
                                                        onClick={togglePdfModal}
                                                    >
                                                        <i className="ri-file-pdf-line fs-4 me-1"></i> Voir la facture
                                                    </Button>
                                                )}
                                            </Col>
                                            <Col md={4} className="text-end">
                                                <span className="text-danger fw-semibold">
                                                    Reste à payer: {order?.resteapayer.toFixed(2)} €
                                                    {order?.paiements.paiements.length > 0 && (
                                                        <>
                                                            <i
                                                                className="ri-information-line ms-2 text-primary fs-4"
                                                                id={`restePopover-${order.id}`}
                                                                style={{ cursor: "pointer" }}
                                                            />
                                                            <UncontrolledPopover
                                                                placement="bottom"
                                                                target={`restePopover-${order.id}`}
                                                                trigger="hover"
                                                            >
                                                                <PopoverHeader>Historique des paiements</PopoverHeader>
                                                                <PopoverBody>
                                                                    <table className="table table-sm table-bordered mb-0">
                                                                        <thead>
                                                                            <tr>
                                                                                <th>Date</th>
                                                                                <th>Montant</th>
                                                                                <th>Méthode</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {order.paiements.paiements.map(
                                                                                (payment, index) => (
                                                                                    <tr key={index}>
                                                                                        <td>
                                                                                            {payment.date
                                                                                                ? new Date(payment.date).toISOString().split("T")[0]
                                                                                                : "-"}
                                                                                        </td>
                                                                                        <td>{Number(payment.amount).toFixed(2)} €</td>
                                                                                        <td>{convertPaymentType(payment.type_paiement)}</td>
                                                                                    </tr>
                                                                                )
                                                                            )}
                                                                        </tbody>
                                                                    </table>
                                                                </PopoverBody>
                                                            </UncontrolledPopover>
                                                        </>
                                                    )}
                                                </span>
                                            </Col>
                                        </Row>
                                    </CardHeader>
                                    <CardBody>
                                        <Row>
                                            <Col md={6}>
                                                <div>
                                                    <Label className="form-label text-muted small mb-1">
                                                        Client
                                                    </Label>
                                                    <p className="fw-medium mb-0">{order.client}</p>
                                                </div>
                                            </Col>
                                            <Col md={3}>
                                                <div>
                                                    <Label className="form-label text-muted small mb-1">
                                                        Date
                                                    </Label>
                                                    <p className="text-muted mb-0">{order.date}</p>
                                                </div>
                                            </Col>
                                            <Col md={3}>
                                                <div>
                                                    <Label className="form-label text-muted small mb-1">
                                                        Total TTC
                                                    </Label>
                                                    <p className="fw-semibold mb-0 fs-5 text-success">
                                                        {Number(order?.total_ttc).toFixed(2)} €
                                                    </p>
                                                </div>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            ) : (
                                <Card
                                    className="mb-3 border border-2 border-primary"
                                    style={{ minHeight: 150, maxHeight: 150, height: 150 }}
                                >
                                    <CardBody className="text-center py-5">
                                        <h5 className="text-muted">Aucune commande sélectionnée</h5>
                                        <p className="text-muted mb-0">
                                            Veuillez sélectionner une facture pour continuer.
                                        </p>
                                    </CardBody>
                                </Card>
                            )}

                            {/* Payment Methods and Numeric Keypad */}
                            <Row className="g-3">
                                {/* Numeric Keypad */}
                                <Col xl={6}>
                                    <Card className="shadow-sm h-90 mb-0">
                                        <CardBody>
                                            <div className="mb-2">
                                                <div className="position-relative">
                                                    <Input
                                                        type="text"
                                                        className="form-control mb-2 pe-4"
                                                        placeholder="Entrez un montant"
                                                        value={montant}
                                                        onChange={handleInputChange}
                                                        disabled={!order || order?.resteapayer === 0}
                                                    />
                                                    {montant && (
                                                        <button
                                                            type="button"
                                                            style={{
                                                                position: 'absolute',
                                                                right: '10px',
                                                                top: '8px',
                                                                border: 'none',
                                                                background: 'none',
                                                                padding: 0,
                                                                cursor: 'pointer',
                                                                color: '#6c757d',
                                                            }}
                                                            onClick={handleClearAll}
                                                        >
                                                            <i className="ri-close-line" ></i>
                                                        </button>
                                                    )}
                                                </div>

                                                {order?.resteapayer !== 0 && errorMessage && (
                                                    <p className="text-danger small mb-0" style={{ fontSize: "13px" }} >{errorMessage}</p>
                                                )}
                                                                                      </div>
                                            <div className="pavenum">
                                                <Row className="g-2">
                                                    <Col xs={4}>
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary btn-md w-100 fs-5"
                                                            style={{ minHeight: "40px" }}
                                                            onClick={() => handleNumberClick("1")}
                                                            disabled={!order || order?.resteapayer === 0}
                                                        >
                                                            1
                                                        </button>
                                                    </Col>
                                                    <Col xs={4}>
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary btn-md w-100 fs-5"
                                                            style={{ minHeight: "40px" }}
                                                            onClick={() => handleNumberClick("2")}
                                                            disabled={!order || order?.resteapayer === 0}
                                                        >
                                                            2
                                                        </button>
                                                    </Col>
                                                    <Col xs={4}>
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary btn-md w-100 fs-5"
                                                            style={{ minHeight: "40px" }}
                                                            onClick={() => handleNumberClick("3")}
                                                            disabled={!order || order?.resteapayer === 0}
                                                        >
                                                            3
                                                        </button>
                                                    </Col>
                                                </Row>
                                                <Row className="g-2 mt-2">
                                                    <Col xs={4}>
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary btn-md w-100 fs-5"
                                                            style={{ minHeight: "40px" }}
                                                            onClick={() => handleNumberClick("4")}
                                                            disabled={!order || order?.resteapayer === 0}
                                                        >
                                                            4
                                                        </button>
                                                    </Col>
                                                    <Col xs={4}>
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary btn-md w-100 fs-5"
                                                            style={{ minHeight: "40px" }}
                                                            onClick={() => handleNumberClick("5")}
                                                            disabled={!order || order?.resteapayer === 0}
                                                        >
                                                            5
                                                        </button>
                                                    </Col>
                                                    <Col xs={4}>
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary btn-md w-100 fs-5"
                                                            style={{ minHeight: "40px" }}
                                                            onClick={() => handleNumberClick("6")}
                                                            disabled={!order || order?.resteapayer === 0}
                                                        >
                                                            6
                                                        </button>
                                                    </Col>
                                                </Row>
                                                <Row className="g-2 mt-2">
                                                    <Col xs={4}>
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary btn-md w-100 fs-5"
                                                            style={{ minHeight: "40px" }}
                                                            onClick={() => handleNumberClick("7")}
                                                            disabled={!order || order?.resteapayer === 0}
                                                        >
                                                            7
                                                        </button>
                                                    </Col>
                                                    <Col xs={4}>
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary btn-md w-100 fs-5"
                                                            style={{ minHeight: "40px" }}
                                                            onClick={() => handleNumberClick("8")}
                                                            disabled={!order || order?.resteapayer === 0}
                                                        >
                                                            8
                                                        </button>
                                                    </Col>
                                                    <Col xs={4}>
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary btn-md w-100 fs-5"
                                                            style={{ minHeight: "40px" }}
                                                            onClick={() => handleNumberClick("9")}
                                                            disabled={!order || order?.resteapayer === 0}
                                                        >
                                                            9
                                                        </button>
                                                    </Col>
                                                </Row>
                                                <Row className="g-2 mt-2">
                                                    <Col xs={4}>
                                                        <button
                                                            type="button"
                                                            className="btn btn-danger btn-md w-100 fs-5"
                                                            style={{ minHeight: "40px" }}
                                                            onClick={handleBackspace}
                                                            disabled={!order || order?.resteapayer === 0}
                                                        >
                                                            <i className="ri-arrow-go-back-line"></i>
                                                        </button>
                                                    </Col>
                                                 
                                                    <Col xs={4}>
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary btn-md w-100 fs-5"
                                                            style={{ minHeight: "40px" }}
                                                            onClick={() => handleNumberClick("0")}
                                                            disabled={!order || order?.resteapayer === 0}
                                                        >
                                                            0
                                                        </button>
                                                    </Col>
                                                    <Col xs={4}>
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary btn-md w-100 fs-5"
                                                            style={{ minHeight: "40px" }}
                                                            onClick={() => handleNumberClick(".")}
                                                            disabled={!order || order?.resteapayer === 0}
                                                        >
                                                            .
                                                        </button>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </CardBody>
                                    </Card>
                                </Col>

                                {/* Payment Methods Card */}
                                <Col xl={6}>
                                    <Card className="shadow-sm h-90 mb-0">
                                        <CardBody>
                                            <div className="mb-3 text-center border-bottom pb-2">
                                                <h5 className="mb-0">
                                                    <span className="text-success">{montant || "0.00"} </span>
                                                </h5>
                                            </div>
                                            <Row className="g-3">
                                                <Col lg={12} sm={12}>
                                                    <div className="form-check card-radio">
                                                        <Input
                                                            id="paymentMethod01"
                                                            name="paymentMethod"
                                                            type="radio"
                                                            className="form-check-input"
                                                            disabled={!isPaymentEnabled}
                                                            onChange={() => handlePaymentSelection("Cheque")}
                                                            checked={selectedPayment === "Cheque"}
                                                        />
                                                        <Label
                                                            className="form-check-label w-100 p-2"
                                                            htmlFor="paymentMethod01"
                                                        >
                                                            <div className="d-flex align-items-center">
                                                                <span className="fs-3 text-muted me-3">
                                                                    <i className="ri-bank-card-line"></i>
                                                                </span>
                                                                <div>
                                                                    <span className="fs-14 d-block text-wrap">
                                                                        Chèque
                                                                    </span>
                                                                    <small className="text-muted">
                                                                        Paiement par chèque
                                                                    </small>
                                                                </div>
                                                            </div>
                                                        </Label>
                                                    </div>
                                                </Col>
                                                <Col lg={12} sm={12}>
                                                    <div className="form-check card-radio">
                                                        <Input
                                                            id="paymentMethod02"
                                                            name="paymentMethod"
                                                            type="radio"
                                                            className="form-check-input"
                                                            disabled={!isPaymentEnabled}
                                                            onChange={() => handlePaymentSelection("Carte Bancaire")}
                                                            checked={selectedPayment === "Carte Bancaire"}
                                                        />
                                                        <Label
                                                            className="form-check-label w-100 p-2"
                                                            htmlFor="paymentMethod02"
                                                        >
                                                            <div className="d-flex align-items-center">
                                                                <span className="fs-3 text-muted me-3">
                                                                    <i className="ri-bank-card-fill"></i>
                                                                </span>
                                                                <div>
                                                                    <span className="fs-14 d-block text-wrap">
                                                                        Carte Bancaire
                                                                    </span>
                                                                    <small className="text-muted">
                                                                        Visa/Mastercard
                                                                    </small>
                                                                </div>
                                                            </div>
                                                        </Label>
                                                    </div>
                                                </Col>
                                                <Col lg={12} sm={12}>
                                                    <div className="form-check card-radio">
                                                        <Input
                                                            id="paymentMethod03"
                                                            name="paymentMethod"
                                                            type="radio"
                                                            className="form-check-input"
                                                            disabled={!isPaymentEnabled}
                                                            onChange={() => handlePaymentSelection("Espèce")}
                                                            checked={selectedPayment === "Espèce"}
                                                        />
                                                        <Label
                                                            className="form-check-label w-100 p-2"
                                                            htmlFor="paymentMethod03"
                                                        >
                                                            <div className="d-flex align-items-center">
                                                                <span className="fs-3 text-muted me-3">
                                                                    <i className="ri-money-dollar-box-fill"></i>
                                                                </span>
                                                                <div>
                                                                    <span className="fs-14 d-block text-wrap">
                                                                        Espèces
                                                                    </span>
                                                                    <small className="text-muted">
                                                                        Paiement en espèces
                                                                    </small>
                                                                </div>
                                                            </div>
                                                        </Label>
                                                    </div>
                                                </Col>
                                            </Row>
                                            {selectedPayment === "Espèce" && isMontantValid() && (
                                                <div className="mt-3">
                                                    <Button
                                                        color="success"
                                                        size="lg"
                                                        className="w-100"
                                                        onClick={handlePayment}
                                                        disabled={!isPaymentEnabled}
                                                    >
                                                        Payer
                                                    </Button>
                                                </div>
                                            )}
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        </Col>

                        {/* Right Column: Factures List */}
                        <Col xl="4">
                            <div className="position-sticky" style={{ top: "80px" }}>
                                <Card className="shadow-sm border border-2 border-primary" style={{ margin: 0, background: "none" }}>
                                    <CardBody style={{ maxHeight: "calc(100vh - 190px)", height: "calc(100vh - 190px)", overflowY: "auto", padding: 8 }}>
                                        {orders.length > 0 ? (
                                            <ul className="list-group">
                                                {orders.map((facture) => (
                                                    <li
                                                        key={facture.id}
                                                        className={`list-group-item fs-14 ${order?.id === facture.id ? 'active-order' : ''}`}
                                                        onClick={() => handleFactureSelect(facture)}
                                                        style={{
                                                            cursor: 'pointer',
                                                            padding: '0.75rem 1.25rem',
                                                            marginBottom: 5,
                                                            backgroundColor: order?.id === facture.id ? 'aliceblue' : '#fff', // ✅ white by default
                                                            border: '1px solid #dee2e6', // Optional: ensures consistent border
                                                            borderRadius: '4px'
                                                        }}
                                                    >
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <span>{facture.ref}</span>
                                                            <span className="text-muted">{Number(facture.total_ttc).toFixed(2)} €</span>
                                                        </div>
                                                        <small className="text-muted">{facture.client}</small>
                                                    </li>
                                                ))}
                                            </ul>
                                        ) : (
                                            <p className="text-muted">Aucune facture disponible.</p>
                                        )}
                                    </CardBody>
                                </Card>
                            </div>

                        </Col>
                    </Row>
                </Container>

                {/* Payment Details Modal for Cheque and Carte Bancaire */}
                <Modal isOpen={modalOpen} toggle={handleModalClose}>
                    <ModalHeader toggle={handleModalClose}>
                        {selectedPayment === "Cheque" ? "Détails du Chèque" : "Détails de Transaction"}
                    </ModalHeader>
                    <ModalBody>
                        <FormGroup>
                            <Label for="transactionId">
                                {selectedPayment === "Cheque" ? "Numéro du Chèque" : "Numéro de Transaction"}
                            </Label>
                            <Input
                                type="text"
                                name="transactionId"
                                id="transactionId"
                                value={paymentDetails.transactionId}
                                onChange={handlePaymentDetailsChange}
                                placeholder={
                                    selectedPayment === "Cheque"
                                        ? "Entrez le numéro du chèque"
                                        : "Entrez le numéro de transaction"
                                }
                            />
                        </FormGroup>
                        {selectedPayment === "Cheque" && (
                            <FormGroup>
                                <Label for="bank">Banque</Label>
                                <Input
                                    type="text"
                                    name="bank"
                                    id="bank"
                                    value={paymentDetails.bank}
                                    onChange={handlePaymentDetailsChange}
                                    placeholder="Entrez le nom de la banque"
                                />
                            </FormGroup>
                        )}
                        <Button
                            color="success"
                            size="lg"
                            className="w-100"
                            onClick={handlePayment}
                            disabled={
                                !isPaymentEnabled ||
                                !paymentDetails.transactionId ||
                                (selectedPayment === "Cheque" && !paymentDetails.bank)
                            }
                        >
                            Payer
                        </Button>
                    </ModalBody>
                </Modal>

                {/* PDF Modal */}
                <Modal
                    isOpen={pdfModalOpen}
                    toggle={togglePdfModal}
                    centered
                    size="xl"
                    className="modal-fullscreen-sm-down"
                    style={{ maxWidth: '90vw', maxHeight: '90vh' }}
                >
                    <ModalBody className="p-0" style={{ height: '85vh' }}>
                        {order?.invoicepdf && (
                            <iframe
                                src={order.invoicepdf}
                                title="Facture PDF"
                                style={{ width: '100%', height: '100%', border: 'none' }}
                            />
                        )}
                    </ModalBody>
                </Modal>

                {/* Toast Notification */}
                <div
                    className="position-fixed top-0 end-0 p-3"
                    style={{ zIndex: 1050 }}
                >
                    <Toast isOpen={showToast} className="bg-success text-white">
                        <ToastHeader
                            className="bg-success text-white"
                            toggle={() => setShowToast(false)}
                        >
                            Succès
                        </ToastHeader>
                        <ToastBody>Paiement effectué avec succès!</ToastBody>
                    </Toast>
                </div>
            </div>
        </React.Fragment>
    );
};

export default Caisse;

function convertPaymentType(type_paiement: any): React.ReactNode | Iterable<React.ReactNode> {
    switch (type_paiement) {
        case "CB":
            return "Carte bancaire";
        case "CHQ":
            return "Chèque";
        case "LIQ":
            return "Espèces";
        default:
            return "-";
    }
}